/**
 * Version 0.0.0
 *
 *
 * Author: Oded Sagir
 * @param  Object require -for adding dependencies
 * @return Object         -Class Object
 */
define(function(require) {
    'use strict';

    var template = require('registration-templates/plan-selection/planSelectionBoxView.tmpl');
    var Button = require("ui/button/Button");
    var LEConfig = require("assets/config/le-env-conf");


    // COLLECTION
    var PlansCollection = require('registration-collections/PlansCollection');


    var PlanView = {};
    LE.module('LERegistration', function (LERegistration, LE, Backbone, Marionette, $, _) {

        PlanView = Marionette.ItemView.extend({
            template: template,
            withUIComponents: true,
            className: "plan-box",
            ui: {
                chooseBtn: ".button-choose"
            },

            uiComponents: {
                chooseBtn: {
                    type: Button,
                    options: {
                        el: "view.ui.chooseBtn",
                        permutation: Button.PERMUTATION.BTN_PRIMARY_MARKETING,
                        initState: "view._getChoosePlanBtnState",
                        text: "view._getChoosePlanBtnText"
                    },
                    events: {
                        "click": "_chooseThisPlan"
                    }
                }
            },

            events: {
                "click .billing-dashboard": "_openDashboard"
            },

            initialize: function(options){
                LERegistration.logger.info("PlanView initialized", "PlanView:initialize");
                this.parseTemplateHelpers();
            },

            onRender: function(){
                this.$el.addClass(this.model.get('parsed').planType);
                this.$el.addClass(this.model.get('parsed').planCycle);
                this.$el.addClass(this.model.get('parsed').recommended);
            },

            /**
             * TODO: check why customTemplateHelpers throws an undefined planType error
             * @return {[type]} [description]
             */
            parseTemplateHelpers: function(){
                var parsed= {};
                var USD= this.model.get("ratePlanCharges").USD;

                // plan cycle
                var planCycle;
                switch(this.model.get("baseBillingFrequencyMonths")){
                    case 1:
                    planCycle= PlanView.BILLING_CYCLE.MONTH;
                    break;
                    case 3:
                    planCycle= PlanView.BILLING_CYCLE.QUARTER;
                    break;
                    case 6:
                    planCycle= PlanView.BILLING_CYCLE.SEMI_ANNUAL;
                    break;
                    case 12:
                    planCycle= PlanView.BILLING_CYCLE.ANNUAL;
                    break;
                    case 36:
                    planCycle= PlanView.BILLING_CYCLE.THREE_YEARS;
                    break;
                    default:
                        LERegistration.logger.error("plan cycle is " + this.model.get("baseBillingFrequencyMonths"), "PlanView:parseTemplateHelpers");
                        planCycle= PlanView.BILLING_CYCLE.NULL;
                }
                this.planCycle= planCycle;
                parsed.planCycle= planCycle.class;

                // planType catalog|amendment|current|personal
                parsed.planType= PlansCollection.TYPES[this.model.get("planType")].toLowerCase();

                // flatFeePrice per month
                var flatFeePrice = USD.flatFeePrice/this.model.get("baseBillingFrequencyMonths");
                parsed.flatFeePrice= "$" + Math.round(flatFeePrice);

                // discountPrice per month
                var discountPrice = (USD.flatFeePrice - USD.discountPrice)/this.model.get("baseBillingFrequencyMonths");
                if(!discountPrice){
                    discountPrice= USD.flatFeePrice/this.model.get("baseBillingFrequencyMonths");
                }
                parsed.discountPrice= "$" + Math.round(discountPrice);

                // discount percentage label
                var discountPercentage= parseInt(USD.discountPercentage, 10);
                parsed.discountPercentage= discountPercentage ? LE.translator.translate("LERegistration.plan.discount.percentage").replace("{0}", discountPercentage ) : "";

                // label "per month -paid annualy|quaterly..""
                parsed.paidCycleLabel= LE.translator.translate("LERegistration.planSelection.perMonthLabel").replace("{0}", LE.translator.translate("LERegistration.plan.period." + planCycle.key).toLowerCase() );

                // period total to pay
                var totalPrice = USD.flatFeePrice - (USD.discountPrice ||  0);
                parsed.periodTotal= "$" + Math.round(totalPrice);

                // remove flatFeePrice if equals to discountPrice
                parsed.noDiscount= (parsed.discountPrice == parsed.flatFeePrice) ? "no-discount" : "";

                // period total label
                parsed.periodTotalLabel= LE.translator.translate("LERegistration.planSelection.periodTotalLabel").replace("{0}", LE.translator.translate("LERegistration.plan.period." + planCycle.key) );

                // plan banner label
                parsed.unknowPersonal= false;
                parsed.planBannerLabel= "";
                parsed.recommended= "";
                if(parsed.planType === PlansCollection.TYPES.PERSONAL.toLowerCase()){
                    parsed.planBannerLabel= LE.translator.translate("LERegistration.plan.personal");
                    //TODO: currently Apptus without a discount would return null instead of 0
                    if(USD.discountPrice === null || USD.discountPercentage === null){
                        parsed.unknowPersonal= true;
                    }
                }else if(this.model.get("recommended")){
                    // recommended
                    parsed.planBannerLabel= LE.translator.translate("LERegistration.plan.recommended");
                    parsed.recommended= "recommended";
                }

                // Total savings
                parsed.savings= "$" + Math.round(USD.discountPrice);

                // THE PARSED OBJECT
                // discountPercentage:
                // discountPrice:
                // flatFeePrice:
                // noDiscount:
                // paidCycleLabel:
                // periodTotal:
                // periodTotalLabel:
                // planBannerLabel:
                // planCycle:
                // planType:
                // recommended:
                // savings:
                // unknowPersonal:
                this.model.set("parsed", parsed);
                LERegistration.logger.debug("PlanView parsed model", "PlanView:parseModel", parsed);
            },

            _chooseThisPlan: function(event){
                var selectedPlanName= this.model.get('productRatePlanName');
                LERegistration.logger.info("Pressed the choose a plan button for plan " + selectedPlanName, "PlanView:_chooseThisPlan");
                LERegistration.vent.trigger("planSelectionView:next",this.model);
            },

            /**
             * Incase showing a personal offer box link the get details to this function
             * the lin
             * @param event
             * @private
             */
            _openDashboard: function(event){
                LERegistration.logger.info("Going to billing dashboard", "PlanView:_openDashboard");

                var isTrialDeferred= LERegistration.controller.billingManager.isTrial();
                $.when(isTrialDeferred).done(_.bind(function(isTrial){
                        var onboardInLe= isTrial && LEConfig.Billing.billingInLe;
                        var upgradeInLe= !isTrial && LEConfig.Billing.upgradeInLe;
                        if(onboardInLe || upgradeInLe){
                            LERegistration.controller.openChat();
                        }else{
                            LERegistration.controller.gotoLPComBilling(isTrial);
                        }
                    },this))
                    .fail(_.bind(function(message, errorCode, response) {
                        message+= "isTrial api call has failed upon executing plan selection(no routing version).";
                        this.handleRegistrationError(message, errorCode, null, null, response);
                    },this));
            },

            _getChoosePlanBtnState: function(){
                return PlansCollection.TYPES[this.model.get("planType")] === PlansCollection.TYPES.CURRENT ? Button.STATES.DISABLED : Button.STATES.ENABLED;
            },
            
            _getChoosePlanBtnText: function(){
                return PlansCollection.TYPES[this.model.get("planType")] === PlansCollection.TYPES.CURRENT ? LE.translator.translate("LERegistration.planSelection.choosePlan.buttonLabel.current") : LE.translator.translate("LERegistration.planSelection.choosePlan.buttonLabel");
            }

           
        });
        
    });

    PlanView.BILLING_CYCLE = {
        MONTH       :{key: "month",         class: "month"},
        QUARTER     :{key: "quarter",       class: "quarter"},
        SEMI_ANNUAL :{key: "semi.annual",   class: "semi-annual"},
        ANNUAL      :{key: "annual",        class: "annual"},
        THREE_YEARS :{key: "three.years",   class: "three-years"},
        NULL        :{key: "",              class: ""}
    };
   
    return PlanView;
});